import axios from 'axios';

// Accessories & consumables. The server decides which location's stock you get
// back (own store, or central for central roles) — the client never picks.
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getSupplyStock = async ({ category, locationId } = {}) => {
  const response = await axios.get('/api/supplies/stock', {
    headers: getAuthHeaders(),
    params: { category, locationId },
  });
  return response.data;
};

export const getSupplyProducts = async ({ category, includeInactive } = {}) => {
  const response = await axios.get('/api/supplies/products', {
    headers: getAuthHeaders(),
    params: { category, includeInactive: includeInactive ? '1' : undefined },
  });
  return response.data;
};

export const createSupplyProduct = async (payload) => {
  const response = await axios.post('/api/supplies/products', payload, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateSupplyProduct = async (id, payload) => {
  const response = await axios.patch(`/api/supplies/products/${id}`, payload, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Central-only: set or adjust central's own count. Rejected for store users.
export const setSupplyStock = async ({ supplyProductId, qty, delta, reason }) => {
  const response = await axios.patch('/api/supplies/stock', { supplyProductId, qty, delta, reason }, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const requestSupply = async ({ supplyProductId, qty, notes }) => {
  const response = await axios.post('/api/supplies/requests', { supplyProductId, qty, notes }, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getSupplyRequests = async (params = {}) => {
  const response = await axios.get('/api/supplies/requests', {
    headers: getAuthHeaders(),
    params,
  });
  return response.data;
};

// Central-only: hand the goods to the courier. Reserves the stock if the
// request was raised while central's shelf was empty.
export const sendSupplyRequest = async (id) => {
  const response = await axios.post(`/api/supplies/requests/${id}/send`, {}, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const receiveSupplyRequest = async (id) => {
  const response = await axios.post(`/api/supplies/requests/${id}/receive`, {}, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const cancelSupplyRequest = async (id, notes) => {
  const response = await axios.post(`/api/supplies/requests/${id}/cancel`, { notes }, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
